import { ArrowRightIcon } from "lucide-react";
import { FormEventHandler } from "react";
import { Button } from "./ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "./ui/card";
import { FormError } from "./ui/form-error";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

type FormData = {
  address?: string;
  effective_date?: string;
};

type Props = {
  data: FormData;
  setData: (key: keyof FormData, value: string) => void;
  onSubmit: FormEventHandler;
  processing: boolean;
  errors: Partial<Record<keyof FormData, string>>;
};

export default function AdjustmentPropertyForm({
  data,
  setData,
  onSubmit,
  processing,
  errors,
}: Props) {
  return (
    <form onSubmit={onSubmit}>
      <Card className="w-full">
        <CardHeader>
          <CardTitle className="text-2xl">Enter subject property information</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="address">Address</Label>
              <Input
                id="address"
                type="text"
                value={data.address || ""}
                onChange={(e) => setData("address", e.target.value)}
                required
              />
              <FormError error={errors.address} />
            </div>

            <div className="space-y-2">
              <Label htmlFor="effective_date">Effective Date</Label>
              <Input
                id="effective_date"
                type="date"
                value={data.effective_date || ""}
                onChange={(e) => setData("effective_date", e.target.value)}
                required
              />
              <FormError error={errors.effective_date} />
            </div>
          </div>
        </CardContent>
        <CardFooter>
          <div className="flex justify-end w-full">
            <Button type="submit" disabled={processing}>
              {processing ? "Saving..." : "Next"} <ArrowRightIcon className="w-4 h-4" />
            </Button>
          </div>
        </CardFooter>
      </Card>
    </form>
  );
}
